'use client';
import React, { FC, KeyboardEventHandler, MouseEventHandler } from 'react';

import throttle from 'lodash/throttle';
import { ButtonProps } from 'antd/es/button';

import CustomIcon, { SeturIcon } from '@components/utils/CustomIcon';

export const renderNavButton =
  (
    ButtonComponent: FC<ButtonProps>,
    icon: SeturIcon,
    fontSize = 12,
    topSize?: number
  ) =>
  ({
    ariaLabel,
    disabled,
    onClick,
    onKeyUp,
    onMouseUp,
  }: {
    ariaLabel: string;
    disabled: boolean;
    onClick?: MouseEventHandler;
    onKeyUp?: KeyboardEventHandler;
    onMouseUp?: MouseEventHandler;
  }) => {
    const throttledOnClick = onClick
      ? throttle(onClick, 300, { trailing: false })
      : undefined;

    return (
      <ButtonComponent
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={throttledOnClick}
        onKeyUp={onKeyUp}
        onMouseUp={onMouseUp}
        style={{ top: topSize }}
        icon={
          <CustomIcon icon={icon} fontSize={fontSize} paletteColor='darkGray' />
        }
        type='link'
      />
    );
  };
